export enum Format {
  IMAGE_PNG = 'image/png',
  OPEN_LAYER = 'application/openlayers'
}